module.exports = __webpack_public_path__ + "media/images/products/banners/fundos_de_investimento-501fe9836a0a8e50473dea95efb5250e.png";